<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- PPR번호 -->
							<th class="col-1">* {{ getMessage_('QWCC001034') }}</th>
							<td class="position-relative">
								<el-input v-model="detailForm.pprNo" readOnly />
							</td>
							<!-- 검사번호 -->
							<th class="col-1">{{ getMessage_('QWCC000005') }}</th>
							<td class="position-relative">
								<el-input v-model="detailForm.ckuNo" readOnly />
							</td>
							<!-- OS_D번호 -->
							<th class="col-1">{{ getMessage_('QWCC001463') }}</th>
							<td class="position-relative">
								<el-input v-model="detailForm.overSrgNo" readOnly />
							</td>
							<!-- 진행상태 -->
							<th class="col-1">{{ getMessage_('QWCC001094') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.pgsStCd"
									:options="getPgsStKdCdList_"
									:onChange="value => onChangeParam({ key: 'pgsStCd', value })"
									disabled
								/>
							</td>
							<!-- 긴급도 -->
							<th class="col-1">{{ getMessage_('QWCC001418') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.lugyCd"
									:options="getLugyCdList_"
									:onChange="value => onChangeParam({ key: 'lugyCd', value })"
									:disabled="getEditChk"
								/>
							</td>
						</tr>
						<tr>
							<!-- 품번 -->
							<th class="col-1">{{ getMessage_('QWCC000956') }}</th>
							<td><el-input v-model="detailForm.partNo" readOnly /></td>
							<!-- LOT번호(FR) -->
							<th class="col-1">{{ getMessage_('QWCC001470') }}</th>
							<td><el-input v-model="detailForm.lotFromNo" maxlength="20" show-word-limit  :readOnly="getEditChk"/></td>
							<!-- LOT번호(TO) -->
							<th class="col-1">{{ getMessage_('QWCC001469') }}</th>
							<td><el-input v-model="detailForm.lotToNo" maxlength="20" show-word-limit  :readOnly="getEditChk"/></td>
							<!-- LOT수량 -->
							<th class="col-1">{{ getMessage_('QWCC001663') }}</th>
							<td>
								<el-input
									v-model="detailForm.lotQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'lotQty', value })"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- 납품업체 -->
							<th class="col-1">{{ getMessage_('QWCC001341') }}</th>
							<td class="position-relative">
								<el-input v-model="detailForm.cofCd" maxlength="20" show-word-limit  :readOnly="getEditChk"/>
							</td>
						</tr>
						<tr>
							<!-- 발생일자 -->
							<th class="col-1">{{ getMessage_('QWCC001032') }}</th>
							<td class="position-relative">
								<el-date-picker v-model="detailForm.occuDd" type="date" format="yyyy-MM-dd" value-format="yyyyMMdd" :disabled="getEditChk"/>
							</td>
							<!-- 발생장소 -->
							<th class="col-1">{{ getMessage_('QWCC001464') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.occuPlCd"
									:options="getOccuPlCdList_"
									:onChange="value => onChangeParam({ key: 'occuPlCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 검사수량 -->
							<th class="col-1">{{ getMessage_('QWCC000073') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.ckuQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'ckuQty', value })"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- 불량수량 -->
							<th class="col-1">{{ getMessage_('QWCC000074') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.badQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'badQty', value })"
								/>
							</td>
							<!-- 격리수량 -->
							<th class="col-1">{{ getMessage_('QWCC001465') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.sprtQty"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'sprtQty', value })"
									:readOnly="getEditChk"
								/>
							</td>
						</tr>
						<tr>
							<!-- 제기일 -->
							<th class="col-1">{{ getMessage_('QWCC002059') }}</th>
							<td class="position-relative">
								<el-date-picker v-model="detailForm.pprsDd" type="date" format="yyyy-MM-dd" value-format="yyyyMMdd"  :disabled="getEditChk"/>
							</td>
							<!-- 라인정지시간 -->
							<th class="col-1">{{ getMessage_('QWCC001419') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.lnStpTm"
									:clearable="false"
									maxlength="4"
									show-word-limit
									@input="value => inputNumber({ key: 'lnStpTm', value })"
									:readOnly="getEditChk"
								/>
							</td>

							<!-- 클레임유형 -->
							<th class="col-1">{{ getMessage_('QWCC001664') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.clmTypeCd"
									:options="getClmTypeGlsCdList_"
									:onChange="value => onChangeParam({ key: 'clmTypeCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 운송수단 -->
							<th class="col-1">{{ getMessage_('QWCC001665') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.tpWayCd"
									:options="getTpWayCdList_"
									:onChange="value => onChangeParam({ key: 'tpWayCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 소싱구분 -->
							<th class="col-1">{{ getMessage_('QWCC000981') }}</th>
							<td class="position-relative">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.partGCd"
									:options="getPartGCdList_"
									:onChange="value => onChangeParam({ key: 'partGCd', value })"
									disabled
								/>
							</td>
							<!-- <td class="position-relative">
								<el-input v-model="detailForm.partGCd" />
							</td> -->
						</tr>
						<tr>
							<!-- 클레임번호 -->
							<th class="col-1">{{ getMessage_('QWCC001225') }}</th>
							<td class="col-1"><el-input v-model="detailForm.clmNo" readOnly /></td>
							<!-- 결함유형 -->
							<th class="col-1">{{ getMessage_('QWCC001468') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="detailForm.badTypeSgrpNm"
												class="inputWithIcon"
												@keyup.native.delete="() => onBadTypeInPutKeyDown()"
												:readonly="true"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onBadTypeSearchPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>

							<!-- 해외공장 RPT -->
							<th class="col-1">{{ getMessage_('QWCC001667') }}</th>
							<td class="position-relative">
								<el-input
									v-model="detailForm.abrdRprTm"
									maxlength="7"
									show-word-limit
									@input="value => inputNumber({ key: 'abrdRprTm', value })"
									:readOnly="getEditChk"
								/>
							</td>
							<!-- 클레임 진행상태 -->
							<th class="col-1">{{ getMessage_('QWCC001666') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.clmPgsStCd"
									:options="getClmPgsStCdList_"
									:onChange="value => onChangeParam({ key: 'clmPgsStCd', value })"
									:disabled="getEditChk"
								/>
							</td>
							<!-- 판정결과 -->
							<th class="col-1">{{ getMessage_('QWCC001222') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.clmRsltCd"
									:options="getClmRsltCdList_"
									:onChange="value => onChangeParam({ key: 'clmRsltCd', value })"
									:disabled="getEditChk"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			altrNumber: ''
		};
	},
	async mounted() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		// 대책회신 기준으로 활성화, 비활성화
		onChkMdvRplCd() {
			const mdvRplCd = this.detailForm.mdvRplCd;
			if (mdvRplCd === 'RPL10') {
				return false;
			} else {
				return true;
			}
		},

		getEditChk() {
			let editYn = false;
			const pgsStCd = this.detailForm.pgsStCd;
			if (pgsStCd !== undefined && Number(pgsStCd) === 20) {
				editYn = true;
			}
			//console.log('PopupFormInfo getEditChk , pgsStCd>>> ', editYn, pgsStCd);
			return editYn;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		onBadTypeInPutKeyDown() {},
		onBadTypeSearchPopup() {
			let sendParams = {};
			this.$emit('BadTypePopupOpen', sendParams);
		},
		//숫자입력체크
		inputNumber({ key, value }) {
			let numberRegEx = /[^0-9]/g; //숫자만 입력가능
			let val = value.replace(numberRegEx, '');
			this.onChangeParam_({ key: key, value: val });
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -1px;
}
</style>
